
<div class="stepper-header">
    <div v-for="(step, index) in steps" :key="step.value" class="stepper-header__item" :class="{
        'stepper-header__item--active': currentStep === step.value,
        'stepper-header__item--completed': currentStep > step.value,
        'stepper-header__item--clickable': clickable
    }" @click="onStepClick(step.value)">
        <div class="stepper-header__step">
            <v-icon :color="getIconColor(step.value)" size="18">
                {{ step.icon }}
            </v-icon>
            <span class="stepper-header__label">{{ step.value }}. {{ step.label }}</span>
        </div>
        <div class="stepper-header__underline"></div>
    </div>
</div>
